import React from 'react';
import { View, StyleSheet, type StyleProp, type ViewStyle } from 'react-native';

interface SkeletonCardProps {
  children: React.ReactNode;
  padding?: number;
  borderRadius?: number;
  backgroundColor?: string;
  borderColor?: string;
  borderWidth?: number;
  style?: StyleProp<ViewStyle>;
}

export const SkeletonCard: React.FC<SkeletonCardProps> = React.memo(({
  children,
  padding = 16,
  borderRadius = 14,
  backgroundColor,
  borderColor,
  borderWidth,
  style,
}) => (
  <View
    style={[
      styles.card,
      {
        padding,
        borderRadius,
        ...(backgroundColor && { backgroundColor }),
        ...(borderColor && { borderColor, borderWidth: borderWidth ?? 1 }),
      },
      style,
    ]}
  >
    {children}
  </View>
));

SkeletonCard.displayName = 'SkeletonCard';

const styles = StyleSheet.create({
  card: {
    gap: 10,
    overflow: 'hidden',
  },
});
